import onChange from 'on-change';
import selectors from '../globals/selectors';
import classNames from '../globals/classNames';
import disablePageScroll from '../helpers/disablePageScroll';
import enablePageScroll from '../helpers/enablePageScroll';

const toggleFilter = (filterEl, isVisible) => {
	filterEl.classList.toggle(classNames.catalog.filter.isVisible, isVisible);

	if (isVisible) {
		disablePageScroll();
	} else {
		enablePageScroll();
	}
};

export default () => {
	const state = {
		isVisible: false,
	};

	const filterEl = document.querySelector(selectors.catalog.filter);
	const filterToggleEl = document.querySelector(selectors.catalog.filterToggle);
	const closeEl = document.querySelector(selectors.catalog.close);

	const watchedState = onChange(state, () =>
		toggleFilter(filterEl, state.isVisible)
	);

	filterToggleEl.addEventListener('click', () => {
		watchedState.isVisible = true;
	});

	closeEl.addEventListener('click', () => {
		watchedState.isVisible = false;
	});
};
